import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import './Orders.css';
import { ORDERS_ITEM_LINK, ORDERS_ITEM_V2_LINK, ORDERS_MAIN_LINK, PLATFORM_MAIN_LINK } from '../../../assets/utils/constants';
import OrdersList from './OrdersList/OrdersList';
import OrderPage from './OrderPage/OrderPage';
import OrderPageV2 from './OrderPageV2/OrderPageV2';

function Orders() {



    return (
        <div className='orders'>
            <Routes>
                <Route index element={
                    <OrdersList />
                }>
                </Route>
                <Route path={`${ORDERS_ITEM_V2_LINK}`} element={
                    <Navigate replace to={`${PLATFORM_MAIN_LINK}/${ORDERS_MAIN_LINK}`} />
                }>
                </Route>
                <Route path={`${ORDERS_ITEM_V2_LINK}/:id/*`} element={
                    <OrderPageV2 />
                }>
                </Route>
                <Route path={`${ORDERS_ITEM_LINK}/:id/*`} element={
                    <OrderPage />
                }>
                </Route>

            </Routes>
        </div>
    );
}

export default Orders




